import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { ProductiveHeading06, TextWrapper } from 'ozone/atoms';

const Wrapper = styled.section`
  display: flex;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background: var(--white-100);
`;

const Heading = styled(TextWrapper)`
  padding: ${({ theme }) => theme.spacing.double};
  padding-bottom: ${({ theme }) => theme.spacing.normal};
  box-shadow: var(--shadow-02);
`;

const Children = styled.div`
  max-width: 80rem;
  padding: ${({ theme }) => theme.spacing.double};
`;

interface Props {
  title: ReactNode;
}

export const SubPage: FC<Props> = ({ title, children }) => (
  <Wrapper>
    <Content>
      <StickyHeader>
        <Heading>
          <ProductiveHeading06>{title}</ProductiveHeading06>
        </Heading>
      </StickyHeader>
      <Children>{children}</Children>
    </Content>
  </Wrapper>
);
